<template>
  <!-- 论文发布页 -->
  <div class="form-content-container">
    <Form
      class="form-container"
      ref="formValidateRef"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="left"
    >
      <FormItem
        ref="FormItemTitle"
        class="form-item"
        prop="title"
        :rules="[
          { required: true, message: '标题不能为空', trigger: 'change | blur' },
          { validator: validatetitle, trigger: 'change | blur' },
        ]"
      >
        <div class="title titleRichEditor">
          <!-- <Input
            class="titleInput"
            v-model="formValidate.title"
            :autosize="true"
            type="textarea"
            placeholder="请输入标题(5-50字)"
          /> -->
          <!--  @changeValue="formValidate.content = $event" -->
          <title-summary-editor
            v-if="titleFocus"
            bodyClass="chineseTitle"
            :id="'chineseTitle'"
            v-model.trim="formValidate.title"
            :initWithBold="true"
            initFontSize="36px"
            :minHeight="62"
            :placeholder="titlePlaceHolder"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <div class="number">
          <span :class="wordCount > 50 ? 'fontColor' : ''">{{
            wordCount
          }}</span>
          / 50
        </div>
      </FormItem>
      <FormItem
        ref="FormItemEnglishTitle"
        class="form-item"
        label="英文标题"
        prop="englishTitle"
        :rules="[
          {
            type: 'string',
            pattern:
              /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
            message: '请勿填写中文',
            trigger: 'change | blur',
          },
          { validator: validateEnglishTitle, trigger: 'change | blur' },
        ]"
      >
        <div class="title">
          <title-summary-editor
            bodyClass="englistTitle"
            :id="'englishTitle'"
            v-model="formValidate.englishTitle"
            :initWithBold="false"
            initFontSize="14px"
            :minHeight="62"
            :placeholder="titleEnPlaceHolder"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
      </FormItem>
      <FormAuther
        @autherInfo="handleAuther"
        @autherInfo2="handleAuther2"
        :formValidate="formValidate"
        :isPaper="true"
      ></FormAuther>
      <FormItem class="form-item" prop="keyword" label="关键词">
        <Input
          placeholder="请输入关键词，多个关键词之间用英文逗号“,”隔开"
          v-model.trim="formValidate.keyword"
        />
        <!-- <span class="required">*</span> -->
      </FormItem>
      <FormItem class="form-item" label="Keywords" prop="englishKeyword">
        <Input
          placeholder="请输入英文关键词，多个关键词之间用英文逗号“,”隔开"
          v-model="formValidate.englishKeyword"
        />
      </FormItem>
      <FormItem
        ref="FormItemArtSummary"
        class="form-item"
        label="摘要"
        prop="artSummary"
        :rules="[
          { required: true, message: '摘要不能为空', trigger: 'change | blur' },
          { validator: validateArtSummary, trigger: 'change | blur' },
        ]"
      >
        <!-- <Input
          type="textarea"
          :rows="4"
          placeholder="请输入摘要"
          v-model.trim="formValidate.artSummary"
        /> -->
        <div class="title titleRichEditor artSummaryEditor">
          <title-summary-editor
            bodyClass="englistTitle"
            :id="'chineseSummary'"
            v-model.trim="formValidate.artSummary"
            :initWithBold="false"
            initFontSize="14px"
            :minHeight="62"
            :placeholder="summaryPlaceHolder"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <!-- <div class="number">
          <span :class="summaryWordCount > 1000 ? 'fontColor' : ''">{{
            summaryWordCount
          }}</span>
          / 1000
        </div> -->
      </FormItem>
      <FormItem class="form-item" ref="FormItemEnglishArtSummary" label="Abstract" prop="englishArtSummary">
        <title-summary-editor
          bodyClass="englistTitle"
          :id="'englishSummary'"
          v-model="formValidate.englishArtSummary"
          :initWithBold="false"
          initFontSize="14px"
          :minHeight="62"
          :placeholder="summaryEnPlaceHolder"
          @changeValue="getTitle"
        ></title-summary-editor>
      </FormItem>
      <FormItem class="form-item" prop="periodical" label="期刊名称">
        <Input
          placeholder="请输入刊名"
          v-model.trim="formValidate.periodical"
        />
        <!-- <span class="required">*</span> -->
      </FormItem>
      <FormItem class="form-item" label="Journal" prop="englishPeriodical">
        <Input
          placeholder="请输入英文刊名"
          v-model="formValidate.englishPeriodical"
        />
      </FormItem>
      <FormItem class="form-item timeItme" label="刊期">
        <div class="year">
          <FormItem prop="journalsYear" style="width: 100%">
            <DatePicker
              :value="formValidate.journalsYear"
              type="year"
              placeholder="请输入年份"
              @on-change="formValidate.journalsYear = $event"
              style="width: 100%"
            >
            </DatePicker>
            <span class="required">*</span>
          </FormItem>
        </div>
        <div class="center">
          <Input
            placeholder="请输入卷数"
            maxlength="4"
            v-model.trim="formValidate.journalsVolume"
          />
        </div>
        <div class="stage">
          <FormItem prop="journalsTerm" style="width: 100%">
            <Input
              placeholder="请输入期数"
              maxlength="5"
              v-model.trim="formValidate.journalsTerm"
            />
            <span class="required">*</span>
          </FormItem>
        </div>
      </FormItem>
      <FormItem class="form-item" prop="articleColumn" label="期刊栏目">
        <Input
          placeholder="请输入栏目"
          v-model.trim="formValidate.articleColumn"
        />
        <!-- <span class="required">*</span> -->
      </FormItem>
      <FormItem class="form-item" prop="classifyNumber" label="分类号">
        <Input
          placeholder="请输入分类号"
          v-model.trim="formValidate.classifyNumber"
        />
        <!-- <span class="required">*</span> -->
      </FormItem>
      <CapitalModel
        @handleFund="handleFund"
        :projectArr="formValidate.tempFundIds"
      ></CapitalModel>
      <FormItem class="form-item" prop="doi" label="DOI">
        <Input placeholder="请输入DOI" v-model.trim="formValidate.doi" />
        <!-- <span class="required">*</span> -->
      </FormItem>
      <FormItem class="form-item" prop="pageNumber" label="页数">
        <Input
          placeholder="请输入页数"
          type="number"
          v-model.trim="formValidate.pageNumber"
        />
        <!-- <span class="required">*</span> -->
      </FormItem>
      <FormItem class="form-item timeItme" label="页码">
        <div class="year">
          <FormItem prop="startPageNumber" style="width: 100%">
            <Input
              placeholder="请输入开始页码"
              type="number"
              v-model.trim="formValidate.startPageNumber"
            />
            <span class="required">*</span>
          </FormItem>
        </div>
        <div class="center">
          <FormItem prop="endPageNumber" style="width: 100%">
            <Input
              placeholder="请输入结束页码"
              type="number"
              v-model.trim="formValidate.endPageNumber"
            />
            <span class="required">*</span>
          </FormItem>
        </div>
        <div class="stage">
          <Input
            placeholder="请输入转接页码"
            type="number"
            v-model.trim="formValidate.turnPageNumber"
          />
        </div>
      </FormItem>
      <FormItem class="form-item" label="数据库收录">
        <CheckboxGroup v-model.trim="formValidate.include">
          <Checkbox
            v-for="v in includeList"
            :key="v.id"
            :label="v.id"
          >{{v.dbName}}</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem
        class="form-item"
        label="附件"
        prop="accessoryName"
        ref="FormItemAccessoryName"
      >
        <FileUplode
          :fileName="formValidate.accessoryName"
          @isUpload="isUpload"
          @handlefileUpload="handlefileUpload"
        />
        <!-- <span class="required">*</span> -->
      </FormItem>
      <FormItem class="form-item columnItem" label="发布栏目">
        <!-- <Checkbox v-model="formValidate.synchronizedStatus"></Checkbox>
        <span>{{ columnNum }}</span> -->
        <Tree
          :data="treeList"
          show-checkbox
          @on-check-change="changeCheck"
        ></Tree>
      </FormItem>
      <!-- 预览/保存/发布按钮 -->
      <div class="submit-container">
        <Button @click="preview" :disabled="isShow" v-throttleClick="2000"
          >预览</Button
        >
        <Button
          :disabled="isUploadState || canClick"
          @click="handleSubmit(formValidate, 1)"
          v-throttleClick="2000"
          >保存</Button
        >
        <Button
          :disabled="isUploadState || canClick"
          @click="handleSubmit(formValidate, 0)"
          v-throttleClick="2000"
          >发布</Button
        >
      </div>
    </Form>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>

<script>
import FormAuther from "../../components/FormAuther.vue";
import CapitalModel from "../../components/CapitalModel.vue";
import FileUplode from "../../components/fileUplode.vue";
import { mapState } from "vuex";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
import ruleUtils from "@/utils/ruleValidate.js";
import TitleSummaryEditor from "@/views/PCView/user/components/TitleSummaryEditor";

export default {
  components: {
    FormAuther,
    CapitalModel,
    AuthenticationModel,
    FileUplode,
    TitleSummaryEditor,
  },
  created() {
    // 校验用户是否完成认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
      return;
    }
    // 获取发布栏目内容
    this.projectAndColumnListByType({ type: 2 });
    this.getIncludeList(); // 数据库收录
    if (this.$route.query.id) {
      // 修改论文回显
      this.getEcho(this.formValidate);
      this.isShow = false;
    } else {
      setTimeout(() => {
        this.getTrees();
      }, 1000);
    }
  },
  mounted() {
    this.titleFocus = true;
  },
  data() {
    return {
      titleFocus: false,
      isShow: true,
      canClick: false,
      wordCount: 0,
      englishTitleCount: 0,
      summaryWordCount: 0,
      titlePlaceHolder: "请输入标题(0~50)字",
      titleEnPlaceHolder: "请输入英文标题(0~500)字",
      summaryPlaceHolder: "请输入摘要(0~1000)字",
      summaryEnPlaceHolder: "请输入英文摘要",
      isUploadState: false,
      checked: false,
      isFlag: false,
      tempArr: [],
      treeList: [], //发布栏目
      includeList: [],
      ismodify: 1,
      formValidate: {
        // 表单数据
        firstAuther: "",
        firstAuthorId: "",
        firstUnit: "",
        firstUnitId: "",
        englishFirstAuthor: "",
        communicationAuthor: "",
        communicationAuthorId: "",
        communicationAuthorUnit: "",
        communicationAuthorUnitId: "",
        englishCommunicationAuthor: "",
        showTitle: "", // 富文本内容
        title: "", // 去除标签之后的用户输入内容
        showEnglishTitle: "", // 富文本内容
        englishTitle: "",
        keyword: "",
        englishKeyword: "",
        showChineseSummary: "",
        artSummary: "",
        showEnglishSummary: "",
        englishArtSummary: "",
        periodical: "",
        englishPeriodical: "",
        journalsYear: "",
        journalsVolume: "",
        journalsTerm: "",
        articleColumn: "",
        classifyNumber: "",
        doi: "",
        interest: [], // 栏目
        include: [], // 数据库收录
        articleAuthorList: [
          // 其他作者
          {
            authorName: "",
            authorId: "",
            authorUnit: "",
            authorUnitId: "",
            englishAuthorName: "",
            otherUnitObj: {},
            showSelect1: false,
            unitSelect: true,
            unitInput: false,
          },
        ],
        startPageNumber: "", //开始页码
        endPageNumber: "", //结束页码
        turnPageNumber: "", //转接页码
        pageNumber: "", //页数
        fundIds: [], // 资金项目
        tempFundIds: [], // 资金项目
        filePath: "", // 文件路径
        accessoryName: "", // 文件名称
        synchronizedStatus: false,
      },
      ruleValidate: ruleUtils,
      previewData: {
        data: {
          articleId: this.$route.query.id ? this.$route.query.id : "",
          articleType: 0,
        },
      },
    };
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    columnNum() {
      let str = "";
      if (sessionStorage.getItem("isSon") === "false") {
        if (this.userInfo.user.customerType === 4) {
          str = "百科号";
        } else if (this.userInfo.user.customerType === 5) {
          str = "机构号";
        } else if (
          this.userInfo.user.customerType === 1 ||
          this.userInfo.user.customerType === 2
        ) {
          str = "百家号";
        }
      } else {
        if (this.userInfo.user.subType === 1) {
          str = "百科号";
        } else if (this.userInfo.user.subType === 2) {
          str = "机构号";
        }
      }
      return str;
    },
  },
  watch: {
    "formValidate.accessoryName"() {
      this.$refs.FormItemAccessoryName.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    "formValidate.title"() {
      this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    "formValidate.englishTitle"() {
      this.$refs.FormItemEnglishTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    "formValidate.artSummary"() {
      this.$refs.FormItemArtSummary.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    "formValidate.englishArtSummary"() {
      this.$refs.FormItemEnglishArtSummary.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
  },
  methods: {
    // 预览
    async preview() {
      const resp = await this.$apis.userServe.setPreview({
        ...this.previewData.data,
      });

      let URL = this.$router.resolve({
        path: "/paperpreview",
        query: {
          articleId: resp.data,
        },
      });
      window.open(URL.href, "_blank");
    },
    // 中文标题校验
    validatetitle(rule, value, callback) {
      if (this.wordCount < 5 || this.wordCount > 50) {
        return callback(new Error("标题限制5到50个字数"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    // 英文标题校验
    validateEnglishTitle(rule, value, callback) {
      if (
        this.formValidate.englishTitle &&
        this.formValidate.englishTitle.length > 500
      ) {
        return callback(new Error("英文标题超出字数限制"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    // 中文摘要校验
    validateArtSummary(rule, value, callback) {
      if (this.summaryWordCount > 1000) {
        return callback(new Error("内容摘要超出字数限制"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    getTitle(params) {
      /* params接收富文本对象，以JSON字符串方式传递，需解析为对象；
      解析后格式如{id: "englishTitle",value:{default: ""}} */
      params = JSON.parse(params);
      // 获取富文本输入框ID，用于区分
      var editorId = params.id;

      // params.value获取富文本输入框的值，有两种可能的值，默认为对象类型 value:{default: ""}；一旦有值，则变为字符串类型，如value: '<p style="line-height: 1.5;">&nbsp;'
      let originalText = params.value; // 获取富文本输入框原始值
      if (typeof originalText == "object") originalText = "";

      // 定义正则表达式reg 过滤标签（无法正常保留<>,如遇<某某决议>这种，还需修改正则）
      var reg = new RegExp("<[^<>]+>", "g");
      // 过滤后的字符串内容，用于统计字数
      console.log(originalText,'originalText');
      let countText = originalText.replace(reg, "");

      // 现将特殊字符$nbsp;替换成空格然后将其他特殊字符匹配成1来便于计数
      var reg2 = /\&[0-9a-z]+;/g;
      countText = countText.replace(/&nbsp;/gi, "");
      if (countText.match(reg2) != null && countText.match(reg2).length != 0) {
        countText = countText.replace(reg2, "1");
      }
      // 将原值中的额$nbsp;替换为普通空格(html中的空格)
      originalText = originalText.replace(/&nbsp;/gi, "");

      // 不为空时，保留sub,sup标签，过滤其他标签
      // console.log(originalText,'originalText');
      originalText = originalText.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
      originalText = originalText.trim();
      // 去掉头尾空格以计数
      countText = countText.trim();

      if (editorId == "chineseTitle") {
        this.formValidate.showTitle = countText;
        this.formValidate.title = originalText;
        countText = this.filterSubSup(countText);
        this.wordCount = countText.length;
        this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      } else if (editorId == "englishTitle") {
        this.formValidate.showEnglishTitle = originalText;
        this.formValidate.englishTitle = originalText;
        countText = this.filterSubSup(countText);
        this.englishTitleCount = countText.length;
        this.$refs.FormItemEnglishTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      } else if (editorId == "chineseSummary") {
        this.formValidate.artSummary = originalText;
        countText = this.filterSubSup(countText);
        this.summaryWordCount = countText.length;
        this.$refs.FormItemArtSummary.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      } else if (editorId == "englishSummary") {
        this.formValidate.englishArtSummary = originalText;
        this.$refs.FormItemEnglishArtSummary.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      }
    },
    // 过滤字符串中的sub/sup标签，返回过滤后的字符串。以计字数
    filterSubSup(s) {
      if (s.indexOf("<sub>") != -1 || s.indexOf("<sup>") != -1) {
        s = s.replace(/<sub>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
        s = s.replace(/<sup>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
      }
      return s;
    },
    isUpload(state) {
      this.isUploadState = state;
    },
    handlefileUpload(url, name) {
      this.formValidate.filePath = url;
      this.formValidate.accessoryName = name;
    },
    getTrees() {
      this.treeList = this.treeList.map((item) => {
        return {
          title: item.projectName,
          expand: true,
          menuIds: item.projectId,
          checked: false,
          children:
            item.columns &&
            item.columns.map((v) => {
              return {
                title: v.columnName,
                menuIds: item.projectId,
                id: v.id,
                checked: false,
              };
            }),
        };
      });
    },
    // 回显
    async getEcho(f) {
      const resp = await this.$apis.userServe.getDetailsByUser({
        articleId: this.$route.query.id,
        articleType: 0,
      });
      this.getTrees();
      // 发布栏目
      resp.data.articlePushList.forEach((itemL) => {
        this.treeList.forEach((itemT) => {
          if (
            itemT.children &&
            itemT.children.length > 0 &&
            itemL.projectId !== undefined
          ) {
            itemT.children.forEach((itemC) => {
              if (itemC.id == itemL.channelId1) {
                itemC["checked"] = true;
              }
            });
          } else {
            if (itemT.menuIds == itemL.projectId) {
              itemT["checked"] = true;
            }
          }
        });
      });

      const r = resp.data.data;
      this.ismodify = r.auditStatus;
      f.title = r.title;
      f.englishTitle = r.englishTitle ? r.englishTitle : '';
      f.keyword = r.keyword;
      f.englishKeyword = r.englishKeyword;
      f.artSummary = r.artSummary;
      f.englishArtSummary = r.englishArtSummary ? r.englishArtSummary : '';
      f.periodical = r.periodical;
      f.englishPeriodical = r.englishPeriodical;
      f.journalsYear = r.journalsYear;
      f.journalsVolume = r.journalsVolume;
      f.journalsTerm = r.journalsTerm;
      f.articleColumn = r.articleColumn;
      f.classifyNumber = r.classifyNumber;
      f.doi = r.doi;
      f.include = resp.data.dataStyleIds.map(item => +item);
      f.pageNumber = r.pageNumber;
      f.filePath = 1; // 文件路径回显为null
      f.accessoryName = r.accessoryName; // 文件名称
      f.articlePushList = r.interest;
      f.firstAuther = r.firstAuthor;
      f.firstAuthorId = r.firstAuthorId;
      f.englishFirstAuthor = r.englishFirstAuthor;
      f.firstUnit = r.firstAuthorUnit;
      f.firstUnitId = r.firstAuthorUnitId ? r.firstAuthorUnitId : "null";
      f.communicationAuthor = r.communicationAuthor
        ? r.communicationAuthor
        : "";
      f.communicationAuthorId = r.communicationAuthorId;
      f.englishCommunicationAuthor = r.englishCommunicationAuthor;
      f.communicationAuthorUnit = r.communicationAuthorUnit;
      f.communicationAuthorUnitId = r.communicationAuthorUnitId
        ? r.communicationAuthorUnitId
        : r.communicationAuthorUnit
        ? "null"
        : r.communicationAuthorUnitId;
      let pageStr = r.sizeNumber.split(",");
      let pageNumStr = pageStr[0].split("-");
      f.startPageNumber = pageNumStr[0]; //开始页码
      f.endPageNumber = pageNumStr[1]; //结束页码
      f.turnPageNumber = pageStr[1] ? pageStr[1] : ''; //转接页码
      f.tempFundIds = r.fundList; // 资金
      // 其他作者
      if (r.articleAuthorList.length > 0) {
        f.articleAuthorList = r.articleAuthorList.map((item) => {
          return {
            authorName: item.authorName,
            authorId: item.authorId,
            authorUnit: item.authorUnit,
            authorUnitId: item.authorUnitId ? item.authorUnitId : "null",
            englishAuthorName: item.englishAuthorName,
            otherUnitObj: {},
            showSelect1: false,
            unitSelect: item.authorId ? true : false,
            unitInput: item.authorUnitId ? false : true,
          };
        });
      }
      f.synchronizedStatus = r.synchronizedStatus == 1 ? true : false;
    },
    handleSubmit(formValidate, status) {
      this.canClick = true;
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      this.$refs.formValidateRef.validate(async (valid) => {
        if (valid) {
          if (this.tempArr.length === 0) {
            this.treeList.forEach((item) => {
              if (item.children && item.children.length > 0) {
                item.children.forEach((v) => {
                  if (v.checked) {
                    this.tempArr.push(v);
                  }
                });
              } else {
                if (item.checked) {
                  this.tempArr.push(item);
                }
              }
            });
          }
          // 发布栏目
          let arr = [];
          this.tempArr.forEach((item) => {
            if (!(item.children && item.children.length > 0)) {
              arr.push({
                projectId: item.menuIds || null,
                channelId1: item.id || null,
              });
            } else {
              return;
            }
          });
          formValidate.interest = [...arr];
          // 其他作者单位 如果填的是其他 自己输入单位名称 单位ID会变成字符串null 传后台要改为空
          let otherArr = formValidate.articleAuthorList.map((item) => {
            let obj = Object.assign({}, item);
            if (obj.authorUnitId === "null") {
              obj.authorUnitId = null;
            }
            return obj;
          });
          // 其他作者只给后台传有其他作者的数组
          otherArr = otherArr.filter((item) => item.authorName !== "");

          // 数据库收录
          let includeName = []
          if (formValidate.include.length > 0) {
            this.includeList.forEach(item => {
              if (formValidate.include.includes(item.id)) includeName.push(item.dbName)
            })
          }
          try {
            const { data } = await this.$apis.userServe.webSave({
              auditStatus: status === 1 ? 1 : this.ismodify === 2 ? 2 : 0, // this.ismodify === 2 已发布修改, status 1是保存 2是发布
              articleType: 0,
              type: 0,
              title: formValidate.title,
              englishTitle: formValidate.englishTitle,
              keyword: formValidate.keyword,
              englishKeyword: formValidate.englishKeyword,
              artSummary: formValidate.artSummary,
              englishArtSummary: formValidate.englishArtSummary,
              periodical: formValidate.periodical,
              englishPeriodical: formValidate.englishPeriodical,
              journalsYear: formValidate.journalsYear,
              journalsVolume:
                formValidate.journalsVolume === ""
                  ? null
                  : formValidate.journalsVolume,
              journalsTerm: formValidate.journalsTerm,
              articleColumn: formValidate.articleColumn,
              classifyNumber: formValidate.classifyNumber,
              doi: formValidate.doi,
              dataStyle: includeName.join(),
              dataStyleIds: formValidate.include,
              pageNumber: formValidate.pageNumber,
              sizeNumber: `${formValidate.startPageNumber}-${
                formValidate.endPageNumber
              }${formValidate.turnPageNumber ? "," : ""}${
                formValidate.turnPageNumber
              }`,
              fundList:
                formValidate.fundIds.length > 0
                  ? formValidate.fundIds
                  : formValidate.tempFundIds,
              filePath: formValidate.filePath, // 文件路径
              accessoryName: formValidate.accessoryName, // 文件名称
              articlePushList: formValidate.interest,
              articleAuthorList: otherArr, // 其他作者
              firstAuthor: formValidate.firstAuther, // 第一作者
              englishFirstAuthor: formValidate.englishFirstAuthor, // 第一作者
              firstAuthorUnit: formValidate.firstUnit,
              firstAuthorUnitId:
                formValidate.firstUnitId === "null"
                  ? null
                  : formValidate.firstUnitId, // 作者单位 如果填的是其他 自己输入单位名称 单位ID会变成字符串null 传后台要改为空
              firstAuthorId: formValidate.firstAuthorId,
              communicationAuthor: formValidate.communicationAuthor, // 通讯作者
              englishCommunicationAuthor: formValidate.englishCommunicationAuthor, // 通讯作者
              communicationAuthorUnit: formValidate.communicationAuthorUnit,
              communicationAuthorUnitId:
                formValidate.communicationAuthorUnitId === "null"
                  ? null
                  : formValidate.communicationAuthorUnitId, // 作者单位 如果填的是其他 自己输入单位名称 单位ID会变成字符串null 传后台要改为空
              communicationAuthorId: formValidate.communicationAuthorId,
              articleId:
                this.$route.query.id || this.previewData.data.articleId || null,
              synchronizedStatus:
                formValidate.synchronizedStatus === true ? 1 : 0,
            });
            if (data.resultCode === "200") {
              this.$Message.success(status === 1 ? "保存成功" : "发布成功");
              this.previewData = data;
              this.isShow = false;
              this.canClick = false;
              if (status === 1) return;
              this.$router.push("/user/contentMrg");
              // this.clearField(); // 清空
            } else {
              this.canClick = false;
              this.$Message.error(data.resultDesc);
            }
          } catch (error) {
            this.canClick = false;
          }
        } else {
          this.canClick = false;
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    // 资金项目
    handleFund(fund) {
      this.formValidate.fundIds = fund;
    },
    handleAuther2(name, userId, unit, orgId) {
      this.formValidate.communicationAuthor = name;
      this.formValidate.communicationAuthorId = userId;
      this.formValidate.communicationAuthorUnit = unit;
      this.formValidate.communicationAuthorUnitId = orgId;
    },
    handleAuther(name, userId, unit, orgId) {
      this.formValidate.firstAuther = name;
      this.formValidate.firstAuthorId = userId;
      this.formValidate.firstUnit = unit;
      this.formValidate.firstUnitId = orgId;
    },
    // 数据库收录
    async getIncludeList() {
      const resp = await this.$apis.xsjhServe.getIncludeList();
      this.includeList = resp.dbList;
    },
    // 发布栏目
    async projectAndColumnListByType(data) {
      const resp = await this.$apis.userServe.projectAndColumnListByType(data);
      this.treeList.push(resp.data[0]);
    },
    changeCheck(item) {
      this.tempArr = item;
    },
    clearField() {
      // 清空
      this.formValidate.firstAuther = "";
      this.formValidate.firstUnit = "";
      this.formValidate.firstUnitId = "";
      this.formValidate.communicationAuthor = "";
      this.formValidate.communicationAuthorUnit = "";
      this.formValidate.communicationAuthorUnitId = "";
      this.formValidate.title = "";
      this.formValidate.keyword = "";
      this.formValidate.artSummary = "";
      this.formValidate.periodical = "";
      this.formValidate.journalsYear = "";
      this.formValidate.journalsVolume = "";
      this.formValidate.journalsTerm = "";
      this.formValidate.articleColumn = "";
      this.formValidate.classifyNumber = "";
      this.formValidate.doi = "";
      this.formValidate.include = null; // 数据库收录
      this.formValidate.articleAuthorList = []; // 其他作者
      this.formValidate.startPageNumber = ""; //开始页码
      this.formValidate.endPageNumber = ""; //结束页码
      this.formValidate.turnPageNumber = ""; //转接页码
      this.formValidate.pageNumber = ""; //页数
      this.formValidate.fundIds = []; // 资金项目
      this.formValidate.filePath = ""; // 文件路径
      this.formValidate.accessoryName = ""; // 文件名称
      this.formValidate.synchronizedStatus = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-tree ul li {
  margin: 0;
}
::v-deep .ivu-tree-children li {
  display: flex;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}

::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected,
.ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
.form-content-container {
  overflow: hidden;
  width: 1200px;
  margin: 38px auto 100px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 32px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.ivu-upload ::v-deep .ivu-upload-drag {
  border: none;
  display: flex;
  align-items: center;
}
::v-deep .ivu-upload {
  // height: 38px;
  display: flex;
  align-items: center;
}
.ivu-input-wrapper ::v-deep textarea {
  border: none;
}

::v-deep .ivu-form-item-error-tip {
  padding-left: 7px !important;
}
::v-deep .form-item:first-child .ivu-form-item-error-tip {
  // padding-left: 0 !important;
}
::v-deep .form-item:first-child {
  // margin-bottom: 10px !important;
}
::v-deep .ivu-form .ivu-form-item-label {
  // padding-top: 8px !important;
}
#chineseTitle {
  padding-right: 50px;
}
// #englishTitle {
//   padding-right: 68px;
// }
// #chineseSummary {
//   padding-right: 80px;
// }
.form-container {
  margin: 0 auto 100px;
  padding: 60px 100px 0;
  width: 1200px;
  min-height: 1228px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .form-item {
    // padding-top: 14px;
    padding-bottom: 25px;
    width: 100%;
    color: #999;
    &::v-deep .ivu-form-item-label {
      min-width: 80px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &::v-deep .ivu-form-item-content {
      display: flex;
      align-items: center;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    ::v-deep .titleRichEditor {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      align-items: flex-end;
      .titleInput {
        flex: 1;
        margin-right: 0px;
      }
    }
    ::v-deep .artSummaryEditor {
      min-height: 60px;
      align-items: flex-start !important;
    }
    .number {
      text-align: right;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .fontColor {
      color: red !important;
    }
    // 标题
    ::v-deep .title {
      flex: 1;
      display: flex;
      align-items: flex-end;
      width: 100%;
      height: 100%;
      // line-height: 38px;
      // padding-top: 14px;
      position: relative;
      #titleEditor {
        font: 400 36px "Microsoft Yahei";
        color: #515a6e;
        width: calc(100% - 60px) !important;
        margin-right: 10px;
      }
      .titleInput {
        flex: 1;
        margin-right: 10px;
      }

      &::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
    }
    .required {
      color: red;
      margin-left: 10px;
    }
  }
  // 年份/卷数/期数/开始/结束/转接页码 item
  .timeItme,
  .columnItem {
    display: flex;
    &::v-deep .ivu-form-item-content {
      display: flex;
      align-items: flex-start;
      flex: 1;
    }
    .year,
    .center,
    .stage {
      display: flex;
      align-items: center;
      margin-right: 5px;
      padding-right: 5px;
      flex: 1;
    }
    .year {
      border-right: 1px solid #dcdcdc;
      &::v-deep .ivu-input-with-suffix {
        border: none;
      }
    }
    .center {
      border-right: 1px solid #dcdcdc;
    }
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
